<template>
    <div class="valuation-layout__car-image-container valuation-vehicle-details__car-image-container">
        <div class="valuation-vehicle-details__img-area">
            <img class="img-responsive valuation-vehicle-details__starburst" src="/images/configurator/stellantis-starburst.svg" alt="Stellantis Starburst">
            <img class="valuation-vehicle-details__vehicle" :src="vehicleImage" alt="Car Image" />
            <p class="valuation-vehicle-details__illustrative-message">Image for illustrative purposes only</p>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    computed: {
        ...mapGetters('ValuationTool', ['vehicleImage']),
    },
}
</script>